import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SkillCard from "./SkillCard.js";
import javascript from "../assets/skills/javascript.svg";
import typescript from "../assets/skills/typescript.svg";
import bash from "../assets/skills/bash.svg";
import linux from "../assets/skills/linux.svg";
import reactIcon from "../assets/skills/react.svg";
import bootstrap from "../assets/skills/bootstrap.svg";
import tailwind from "../assets/skills/tailwind.svg";
import windows from "../assets/skills/windows.svg";
import git from "../assets/skills/git.svg";
import express from "../assets/skills/express.svg";
import html from "../assets/skills/html.svg";
import node from "../assets/skills/nodejs.svg";
import c from "../assets/skills/c.svg";
import cpp from "../assets/skills/cpp.svg";
import java from "../assets/skills/java.svg";
import postgreSQL from "../assets/skills/postgreSQL.svg";
import mongo from "../assets/skills/mongodb.svg";
import mysql from "../assets/skills/mysql.svg";
import css from "../assets/skills/css.svg";
import vscode from "../assets/skills/vscode.svg";
import vue from "../assets/skills/vue.svg";
import ruby from "../assets/skills/ruby.svg";
import rails from "../assets/skills/rails.svg";
import cypress from "../assets/skills/cypress.svg";

export default function Skills() {
  const [showAllCards, setShowAllCards] = useState(false);
  const [slides, setSlides] = useState(4);

  const toggleCardsVisibility = () => {
    setShowAllCards(!showAllCards);
  };
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const width = screen.width;
    if (width < 500) {
      setSlides(2);
    }
  }, []);

  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    slidesToShow: slides,
    slidesToScroll: 1,
  };

  return (
    <div className="mt-4 text-white" id="skills">
      <div className="flex justify-between">
        <div>
          <h1 className="text-2xl font-bold">Skills</h1>
          <p className="font-light text-gray-400">Here are some of my skills</p>
        </div>
        <div>
          <button onClick={toggleCardsVisibility}>
            {showAllCards ? "Show Carousel" : "Show All"}
          </button>
        </div>
      </div>
      {showAllCards ? (
        <div className="grid grid-cols-2 gap-4 mt-4">
          {/* Render all the cards */}
          <SkillCard name="C" img={c} />
          <SkillCard name="C++" img={cpp} />
          <SkillCard name="Java" img={java} />
          <SkillCard name="HTML" img={html} />
          <SkillCard name="CSS" img={css} />
          <SkillCard name="JavaScript" img={javascript} />
          <SkillCard name="TypeScript" img={typescript} />
          <SkillCard name="PostgreSQL" img={postgreSQL} />
          <SkillCard name="MongoDB" img={mongo} />
          <SkillCard name="ExpressJs" img={express} />
          <SkillCard name="ReactJs" img={reactIcon} />
          <SkillCard name="NodeJs" img={node} />
          <SkillCard name="VueJs" img={vue} />
          <SkillCard name="Ruby" img={ruby} />
          <SkillCard name="Rails" img={rails} />
          <SkillCard name="Bootstrap" img={bootstrap} />
          <SkillCard name="Tailwind" img={tailwind} />
          <SkillCard name="MySQL" img={mysql} />
          <SkillCard name="Linux" img={linux} />
          <SkillCard name="Bash" img={bash} />
          <SkillCard name="Git" img={git} />
          <SkillCard name="Windows" img={windows} />
          <SkillCard name="VS Code" img={vscode} />
          <SkillCard name="Cypress" img={cypress} />
        </div>
      ) : (
        <div className="mt-4">
          <Slider {...settings}>
            {/* Render the slider with cards */}
            <SkillCard name="C" img={c} />
            <SkillCard name="C++" img={cpp} />
            <SkillCard name="Java" img={java} />
            <SkillCard name="HTML" img={html} />
            <SkillCard name="CSS" img={css} />
            <SkillCard name="JavaScript" img={javascript} />
            <SkillCard name="TypeScript" img={typescript} />
            <SkillCard name="PostgreSQL" img={postgreSQL} />
            <SkillCard name="MongoDB" img={mongo} />
            <SkillCard name="ExpressJs" img={express} />
            <SkillCard name="ReactJs" img={reactIcon} />
            <SkillCard name="NodeJs" img={node} />
            <SkillCard name="VueJs" img={vue} />
            <SkillCard name="Ruby" img={ruby} />
            <SkillCard name="Rails" img={rails} />
            <SkillCard name="Bootstrap" img={bootstrap} />
            <SkillCard name="Tailwind" img={tailwind} />
            <SkillCard name="MySQL" img={mysql} />
            <SkillCard name="Linux" img={linux} />
            <SkillCard name="Bash" img={bash} />
            <SkillCard name="Git" img={git} />
            <SkillCard name="Windows" img={windows} />
            <SkillCard name="VS Code" img={vscode} />
            <SkillCard name="Cypress" img={cypress} />
          </Slider>
        </div>
      )}
      <div className="line"></div>
      {/**<img src={hr} className="w-full mt-8 md:h-3" alt="hr" />*/}
    </div>
  );
}
